import BookingTypes from "./CBookingTypes";

const Booking__Duration = booking => {
  if (booking.bookingType === BookingTypes.PRIVATE) {
    return booking.privateSession.duration;
  }
  return booking.session.duration;
};
export default Booking__Duration;
